export default {
    messages: {
        _default: (field) => `The field ${field} is not valid`,
        required: (field) => `The field ${field} is required`
      },
    attributes: {
        payer: {
            full_name: 'Full name',
            email: 'E-mail address',
            phone: 'Phone',
        },
        billing_address: {
            street1: 'Address',
            postal_code: 'Zip',
            city: 'City',
            country: 'Country',
        },
        credit_card: {
            number: 'Number',
            security_code: 'Security code',
            expiration_date: 'Expiration date'
        },
    },
};
